
export default  function preprocessMatrixToData(data){
  const text=data;
  const rows = text.split('\n');
  const result = [];
  
  rows.forEach((row, rowIndex) => {
    const columns = row.split(/\s+/);
    columns.forEach((value, colIndex) => {
      if(!value)return;
      result.push({
        x: colIndex,
        y: rowIndex,
        value: parseInt(value)
      });
    });
  });
  
  return result;
};